import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "magnifier",
  "use": "magnifier-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"magnifier\"><path d=\"M17.5 9a9.5 9.5 0 019.5 9.5 9.46 9.46 0 01-2.112 5.973l4.82 4.82-1.415 1.414-4.82-4.82A9.46 9.46 0 0117.5 28a9.5 9.5 0 010-19zm0 2a7.5 7.5 0 100 15 7.5 7.5 0 000-15z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol